import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeSection from './components/sections/HomeSection';
import EventDetailsSection from './components/sections/EventDetailsSection';
import RSVPSection from './components/sections/RSVPSection'
import TravelSection from './components/sections/TravelSection';
import RegistrySection from './components/sections/RegistrySection';

import { LoadScript } from "@react-google-maps/api";

const App = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const renderSection = () => {
    switch (activeSection) {
      case 'home': return <HomeSection setActiveSection={setActiveSection} />;
      case 'details': return <EventDetailsSection />;
      case 'rsvp': return <RSVPSection />;
      case 'travel': return <TravelSection />;
      case 'registry': return <RegistrySection />;
      default: return <HomeSection setActiveSection={setActiveSection} />;
    }
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <div className="min-h-screen" style={{ backgroundColor: "#FDF8F2" }}>
        <Header
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />
        <main className="max-w-6xl mx-auto px-4 py-8">
          {renderSection()}
        </main>
        <Footer />
      </div>
    </LoadScript>
  );
};

export default App;